import { audioType } from '../../../texas/interfaces'
import { useEffect } from 'react'
import { useGameBoardSounds } from './gameBoardSounds'

export const handleResultSFX = (
  audio: audioType,
  flipCard: boolean,
  state: number,
  isLose: boolean,
) => {
  const sfxs = useGameBoardSounds(audio?.volume)
  useEffect(() => {
    if (flipCard && audio?.sound) {
      sfxs.playcardFlipSFX()
      setTimeout(() => {
        if (state === 5 || state === 11) {
          sfxs.playWinSFX()
        }
        if (isLose) {
          sfxs.playLoseSFX()
        }
      }, 500)
    }
  }, [flipCard, state])
}
